export enum UserSettingCategoryCodes {
    BackgroundImage = 'BGIMG',
    DateFormat = 'DATEFORMAT',
    TimeFormat = 'TIMEFORMAT',
    GridSettings = 'GRID',
    Language = 'LANG',
    Theme = 'THEME'
}
